export default {
    create_account_create_title: 'Crear una cuenta',
    create_account_edit_title: 'Editar Cuenta',
    create_account_the_account_was_created: 'La cuenta fue creada',
    create_account_account_name: 'Nombre de la cuenta',
    create_account_account_name_min_error: 'El nombre de la cuenta debe contener un mínimo de caracteres',
    create_account_account_name_max_error: 'El nombre de la cuenta contiene un máximo de caracteres',
    create_account_language: 'Lenguaje',
    create_account_time_zone: 'Zona Horaria',
    create_account_brand: 'Marca',
    create_account_dealer: 'Distribuidor',
    create_account_crm: 'Id. de Salesforce',
    create_account_crm_min_error: 'El CRN debe contener un mínimo de caracteres',
    create_account_internal: 'Interno',
    create_account_yes: 'Si',
    create_account_not: 'No',
    create_account_username: 'Usuario',
    create_account_username_error_min: 'El nombre de usuario debe contener un mínimo de caracteres',
    create_account_username_error_max: 'El nombre de usuario debe contener un máximo de caracteres',
    create_account_email: 'Correo',
    create_account_password: 'Contraseña',
    create_account_role: 'Rol',
    create_account_report_options: 'Opciones de informe',
    create_account_site_options: 'Opciones del sitio',
    create_account_no_options: 'Sin opciones',
    create_account_the_account_has_been_edited: 'La cuenta ha sido editada',
    create_account_general: 'General',
    create_account_packages: 'Paquetes',
    create_account_automatic: 'Automático',
    create_account_manual: 'Manual',
    create_account_click_to_copy_password: 'Haga clic para copiar la contraseña!',
    create_account_the_password_was_copied: 'La contraseña fue copiada',
    create_account_package: 'Paquete',
    create_account_select: 'Seleccionar...',
    create_account_crm_max_error: 'El Id. de Salesforce debe contener un máximo de caracteres',
    create_account_promiles_username: 'Nombre de usuario de Promiles',
    create_account_promiles_email: 'Correo electrónico de Promiles',
    create_account_fuel_card_company_code: 'Código de la tarjeta de combustible',
    create_account_additional_info: 'Información Adicional',
    create_account_error_username: 'El nombre de usuario debe contener sólo letras minúsculas y números, los espacios no son válidos',
    create_account_verify_terms_conditions: 'Verificar los términos y condiciones',
    create_account_verify_terms_conditions_message: 'Al activar esta opción (SÍ) se requiere por parte de los usuarios la aceptación de términos y condiciones durante el proceso de autenticación. Una vez aceptados los T&C, el sistema no vuelve a solicitarlo',
    create_account_speed_limit_engine: 'Límite de velocidad del motor',
    create_account_rgeo_engine: 'Motor Rgeo',
    create_account_osm_with_fallback_google: "OSM con acceso a Google",
    create_account_osm_only: "Sólo OSM",
    create_account_web_service_integration: "WEX EFS",
    create_account_status: "Estado",
    create_account_validate_credentials: "Validar Credenciales",
    create_account_active: "Activo",
    create_account_inactive: "Inactivo",
    create_account_fuel_card_integrations: "Integración de tarjetas de combustible",
    create_account_wex_credencials_success: "Las credenciales son válidas",
    create_account_wex_credencials_error: "Las credenciales no son válidas",
    create_account_wex_credencials_message: "Las credenciales deben validarse",
    create_account_promiles: "Promiles",
    create_account_fuel_cards: "Tarjetas de combustible",
    create_account_web_services_status: "Estado de Servicios Web",
    create_account_tags: "Etiquetas",
    create_account_readonly: "Solo lectura",
    create_account_tag_mode: "Modo de Etiquetas",
    create_account_tag_mode_standard: "Estándar",
    create_account_tag_mode_inheritance: "Herencia",

};